import { generatePath } from 'react-router-dom';
import { createDatasetSlice } from 'src/redux/helpers';
import { pepApiRequest, RequestMethod } from 'src/services';
import {
  API_GET_RULE_CONFIGURATION,
  SOLUTIONS_STORE,
  SOLUTIONS_STORE_RULE_CONFIGURATION,
} from '../constants';
import { mapSolutionRuleConfiguration } from './utils';

const api = (solutionId: string) =>
  pepApiRequest({
    method: RequestMethod.Get,
    url: generatePath(API_GET_RULE_CONFIGURATION, { solutionId }),
  }).then((response) => mapSolutionRuleConfiguration(response));

const ruleConfiguration = createDatasetSlice({
  api,
  storeName: SOLUTIONS_STORE,
  actionName: SOLUTIONS_STORE_RULE_CONFIGURATION,
});

export default ruleConfiguration;
